export class MoleculePanelOverviewHeaderMultiDeleteNameserversetActionComponent {
    public templateUrl = require('./multi-delete-nameserverset-action.html?external');
}
